import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"padding":"0px 12px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "缺少附件", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 批量下载附件 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!

  return (_openBlock(), _createBlock(_component_page_wrapper, null, {
    default: _withCtx(() => [
      _createVNode(_component_we_table, {
        onRegister: _ctx.register,
        dataSource: _ctx.archiveList
      }, {
        contract_name: _withCtx(({ text, record }) => [
          _createVNode(_component_a_button, {
            type: "link",
            onClick: ($event: any) => (_ctx.jumpToContract({ id: record.contract_id }))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(text), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        archive_name: _withCtx(({ text, record }) => [
          (_ctx.canEdit)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "link",
                onClick: ($event: any) => (_ctx.clickItem(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(text), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(text), 1))
        ]),
        files: _withCtx(({ record }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.files, (file, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              onClick: ($event: any) => (_ctx.downloadArchiveAttachFile(file.name, file.path))
            }, _toDisplayString(file.name), 9, _hoisted_2))
          }), 128)),
          ((record.files || []).length === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))
            : _createCommentVNode("", true)
        ]),
        headerButton: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_tooltip, { placement: "bottom" }, _createSlots({
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  disabled: _ctx.getDataSource().filter((x) => x.files.length > 0).length === 0,
                  onClick: _ctx.downloadArchiveAttachFiles
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 2
            }, [
              (_ctx.getDataSource().filter((x) => x.files.filter((f) => !_ctx.isEmptyData(f.path)).length > 0).length === 0)
                ? {
                    name: "title",
                    fn: _withCtx(() => [
                      _hoisted_5
                    ])
                  }
                : undefined
            ]), 1024)
          ])
        ]),
        _: 1
      }, 8, ["onRegister", "dataSource"])
    ]),
    _: 1
  }))
}